export default __webpack_public_path__ + "static/media/icon_right-to-up.291e076a.svg";